// src/auth/googleConfig.js
// Google OAuth configuration

export const googleConfig = {
  clientId: process.env.REACT_APP_GOOGLE_CLIENT_ID || '1095113022965-jeihqu9llfgrh4t6ob0nisk28e0sk5sa.apps.googleusercontent.com',
};

export default googleConfig;
